const quoteHeaderSection = docData => {
  docData.doc.setFontSize(30)
  docData.doc.text('QUOTATION', docData.doc.internal.pageSize.getWidth() / 2, docData.yAxis, { align: 'center' })

  docData.yAxis += docData.buffer

  return docData
}

export default quoteHeaderSection
